
import confetti from 'canvas-confetti';

const main = () => {
    if (!document.querySelector('#page-user-register-complete')) return;
    confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.25 },
        colors: [
            "E9DC17",
            "00A686",
            "4F93CF",
            "EA3373",
            "F5864C",
            "9D65C1",
        ]
    });
}

export default main;
